export const LINE_DATA = [{
  name: 'item 1',
  value: 0
},
{
  name: 'item 2',
  value: 12
},
{
  name: 'item 3',
  value: 16
},
{
  name: 'item 4',
  value: 18
},
{
  name: 'item 5',
  value: 16
},
{
  name: 'item 6',
  value: 15
}, {
  name: 'item 7',
  value: 20
},
{
  name: 'item 8',
  value: 22
},
{
  name: 'item 9',
  value: 24
}, {
  name: 'item 10',
  value: 23
},
{
  name: 'item 11',
  value: 20
},
{
  name: 'item 12',
  value: 16
},
{
  name: 'item 13',
  value: 14
},
{
  name: 'item 14',
  value: 20
}, {
  name: 'item 15',
  value: 25
},
{
  name: 'item 16',
  value: 30
},
{
  name: 'item 17',
  value: 35
},
{
  name: 'item 18',
  value: 40
}
];